export default { sha: '0356fc383cf712a74e23b128cd9719e302859681', buildNumber: 'undefined' }
